export default {
  M: "Male",
  F: "Female",
  Y: "Yes",
  N: "No",
  LessThanMatric: "Less than matric",
  Matric: "Matric",
  "3-yearDiploma": "3-year diploma",
  "3-yearDegreeOr4-yearDiploma": "3-year degree / 4-year diploma",
  "4-yearDegreeOrProfessional": "4-year degree / Professional",
  commission: "Commission",
  fixed: "Fixed",
  NaturalPerson: "Natural person",
  TaxPayingInstitution: "Tax-paying institution",
  TaxExemptInstitution: "Tax-exempt institution",
  Trust: "Trust"
};



// WEBPACK FOOTER //
// ./src/views/Clients/maps/QuoteFieldMap.js